module.exports = __webpack_public_path__ + "img/cauliflower_bread.01a004bd.jpg";